var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoansIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1773_155732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.81 12.4096C21.45 11.8496 20.7 11.6896 20.14 12.0496L17.38 13.8196C17.38 13.8796 17.38 13.9396 17.38 13.9996C17.38 15.2096 16.39 16.1996 15.17 16.1996H11.45C11.17 16.1996 10.95 15.9796 10.95 15.6996C10.95 15.4196 11.17 15.1996 11.45 15.1996H15.17C15.64 15.1996 16.05 14.9296 16.25 14.5396C16.29 14.4596 16.31 14.3896 16.33 14.3196C16.35 14.2396 16.36 14.1596 16.36 14.0696V14.0396C16.36 13.4096 15.86 12.9096 15.24 12.9096H6.66C6.02 12.9096 5.63 12.9596 5.12 13.2596L2.4 14.8196C2.15 14.9696 2 15.2396 2 15.5296V18.5796C2.01 19.0696 2.55 19.3696 2.96 19.0996L5.39 17.5496C5.59 17.4196 5.85 17.3996 6.07 17.4996L11.52 19.9196C11.87 20.0796 12.27 20.0396 12.59 19.8396L21.45 14.0796C22.01 13.7096 22.17 12.9696 21.81 12.4096Z",
    fill: "#8F91A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73438 3H9.10437V5.47C8.41437 5.61 7.90438 6.22 7.90438 6.95C7.90438 7.68 8.41437 8.3 9.10437 8.44V10.91H5.73438C5.18437 10.91 4.73438 10.46 4.73438 9.91V4C4.73438 3.45 5.18437 3 5.73438 3Z",
    fill: "#8F91A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9016 3H10.1016V10.91H13.9016V3Z",
    fill: "#8F91A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2684 4V9.91C19.2684 10.46 18.8184 10.91 18.2684 10.91H14.8984V8.44C15.5784 8.29 16.0984 7.69 16.0984 6.95C16.0984 6.21 15.5784 5.62 14.8984 5.47V3H18.2684C18.8184 3 19.2684 3.45 19.2684 4Z",
    fill: "#8F91A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_155732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.02,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoansIcon);
export default __webpack_public_path__ + "static/media/loans-icon.9c877345e12e89f7f8b1e1349c3a94fa.svg";
export { ForwardRef as ReactComponent };